import ThumbImg from './thumb.png';

export default {
  thumb: ThumbImg,
  url: '/PudgyPenguins',
  footnote: '',
  avatar: '',
  author: '',
};
